import type { Chart } from './types';

// Only the cohort history config carries per-axis series settings, and even
// there the object can be missing on configs that reached the store as a raw
// cast rather than through the validator — hence the presence check and the
// optional chaining below.
export const getWidthMetrics = (config: Chart): string[] => {
  if (!('leftAxisSeries' in config)) {
    return [];
  }

  const widthMetrics = [
    config.leftAxisSeries?.lineWidthMetric,
    config.rightAxisSeries?.lineWidthMetric,
  ].filter((metric): metric is string => {
    return !!metric;
  });

  // Sorted so that moving the same metric from one axis to the other does not
  // read as a different set.
  return [...new Set(widthMetrics)].sort();
};
